/**
 * SSE parser for the chat stream (/api/claude/chat/stream).
 *
 * The server writes each event as `event: <type>\ndata: <json>\n\n`. Network
 * reads cut the stream anywhere, including between an event's two lines, so
 * the parser keeps both the partial line and the event type across reads.
 *
 * Plain JS with no browser APIs: useStreamingChat uses it in the page, and
 * server/scripts/chat-wire-probe.js feeds it the bytes it reads from prod.
 *
 * @param {(type: string|null, data: object) => void} onEvent - called once per
 *   `data:` line with its parsed JSON; may throw (the throw reaches push()'s caller)
 * @returns {{ push: (text: string) => void }}
 */
export function createSseParser(onEvent) {
  let buffer = '';
  let eventType = null;

  return {
    push(text) {
      buffer += text;
      const lines = buffer.split('\n');
      buffer = lines.pop() || ''; // Keep incomplete line in buffer

      for (const line of lines) {
        if (line === '') {
          // A blank line ends the event.
          eventType = null;
        } else if (line.startsWith('event: ')) {
          eventType = line.slice(7).trim();
        } else if (line.startsWith('data: ')) {
          let data;
          try {
            data = JSON.parse(line.slice(6));
          } catch {
            // Ignore parse errors for malformed data
            continue;
          }
          const type = eventType;
          eventType = null;
          onEvent(type, data);
        }
      }
    },
  };
}
